<template>
  <div class="image-states">
    <div class="media-states">
      <div class="state-tag used" v-if="info.createMediaPlan > 0">
        <MediaIcons :value="getPlatformBinaryList(info.createMediaPlan)"></MediaIcons>
        <span class="label">有使用</span>
      </div>
      <div class="state-tag unused" v-else>
        <span class="label">未使用</span>
      </div>
      <div class="state-tag consumed" v-if="info.createMediaCostPlan > 0">
        <MediaIcons :value="getPlatformBinaryList(info.createMediaCostPlan)"></MediaIcons>
        <span class="label">有消耗</span>
      </div>
      <div class="state-tag unconsumed" v-else>
        <span class="label">无消耗</span>
      </div>
    </div>

    <template v-if="showRejection">
      <div class="media-rejections" v-if="mediaRejCounts > 0">
        <el-tooltip effect="dark" placement="top-start">
          <template #content>
            <div class="media-rejection-text">
              <p v-for="(rejText, index) in mediaRejections" :key="index">{{ rejText }}</p>
            </div>
          </template>
          <div class="rej-tags">
            <!-- 拒审媒体标签大于2个，显示两个，其他的折叠 -->
            <el-tag>{{ mediaRejections[0] }}</el-tag>
            <el-tag v-if="mediaRejections[1]">{{ mediaRejections[1] }}</el-tag>
            <el-tag v-if="mediaRejections.length > 2">+{{ mediaRejections.length - 2 }}</el-tag>
          </div>
        </el-tooltip>
      </div>
      <div class="media-rejections" v-else><el-tag>媒体无拒审</el-tag></div>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { BINARY_MEDIA } from '../const'
import MediaIcons from './media-icons.vue'

// eslint-disable-next-line
const props = defineProps({
  info: {
    type: Object,
    default: () => {}
  },
  showRejection: {
    type: Boolean,
    default: true
  }
})
const mediaRejCounts = computed(() => {
  return (props.info.kuaishouRejectCount || 0) + (props.info.toutiaoRejectCount || 0) + (props.info.gdtRejectCount || 0)
})
const mediaRejections = computed(() => {
  const list = []

  if (props.info.gdtRejectCount) list.push(`腾讯拒审${props.info.gdtRejectCount}次`)
  if (props.info.kuaishouRejectCount) list.push(`磁力拒审${props.info.kuaishouRejectCount}次`)
  if (props.info.toutiaoRejectCount) list.push(`巨量拒审${props.info.toutiaoRejectCount}次`)

  return list
})

function getPlatformBinaryList(val) {
  if (val === 0) return 0
  return Object.values(BINARY_MEDIA)
    .filter((bit) => val & bit)
    .map(Number)
}
</script>

<style scoped lang="scss">
.image-states {
  font-size: 12px;
  margin-top: 4px;
  .media-states {
    display: flex;
    .state-tag {
      display: flex;
      align-items: center;
      padding: 3px 8px;
      background: #fdebd3;
      border-radius: 4px;
      color: #a36718;
      margin-right: 4px;

      &.unused,
      &.unconsumed {
        background: #e8e8e8;
        color: #717171;
      }
    }
  }
  .media-rejections {
    margin-top: 2px;
    line-height: 18px;
    .el-tag {
      color: #717171;
      line-height: 16px;
      height: 16px;
      background-color: #e8e8e8;
      margin-right: 2px;
    }
  }
}
</style>
